<template>
  <TheLoader :active="false"/>
</template>

<script>
export default {
  name: 'SearchRedirect',
  created () {
    let query = {}
    if (this.$route.query.kontrakt) {
      query.kontrakt = this.$route.query.kontrakt
      if (this.$route.query.objekt) {
        query.objekt = this.$route.query.objekt
      }
    }

    this.$router.push({
      name: 'KundeCard',
      params: { kunde_id: this.$route.query.kunde_id },
      query: query
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/SearchRedirect.vue